/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { StarFilledIcon as icon } from '../../components/Icons';
import styles from './inline-styles';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Star Rating' ),
	description: __( 'Gutenify Star Rating' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Star Rating' ),
		__( 'rating' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save,
	supports: {
		// html: false,
		// align: [ 'center', 'wide', 'full' ],
	},
	gutenify: {
		customStylesCallback( props ) {
			return styles( props );
		},
	},
};

export { name, category, settings };
